<!-- src/App.vue -->
<template>
  <div id="app">
    <!-- 公共头 -->
    <AppHeader />
    <!-- /公共头 -->

    <router-view />

    <!-- 公共底 -->
    <AppFooter />
    <!-- /公共底 -->
  </div>
</template>

<script>
import AppHeader from './components/AppHeader'
import AppFooter from './components/AppFooter'

import './assets/css/reset.css'
import './assets/css/theme.css'
import './assets/css/global.css'

export default {
  name: 'App',
  components: {
    AppHeader, AppFooter
  },
  created() {
    this.initializeApp()
  },
  methods: {
    async initializeApp() {
      try {
        const token = localStorage.getItem('authToken')
        if (token) {
          await this.$store.dispatch('initializeAuth', token)
        }
      } catch (err) {
        console.error('应用初始化失败:', err)
        // 可以添加错误处理逻辑
      }
    }
  }
}
</script>